import { makeStyles, createStyles } from '@material-ui/styles';

export default makeStyles((theme) => createStyles({
    root: {
        float: 'left',
        paddingLeft: 15
    }
}))